import { ai_agents } from "./ai_agents";
import { broadcasts } from "./broadcasts";
import { courses } from "./courses";
import { devices } from "./devices";
import { events } from "./events";
import { live } from "./live";
import { media } from "./media";
import { members } from "./members";
import { messages } from "./messages";
import { newsletter_posts } from "./newsletter_posts";
import { overview } from "./overview";
import { paywalls } from "./paywalls";
import { post_comments } from "./post_comments";
import { reviews } from "./reviews";
import { spaces } from "./spaces";
import { websites } from "./websites";

export const analytics = {
  ai_agents,
  broadcasts,
  devices,
  events,
  live,
  messages,
  members,
  overview,
  paywalls,
  media,
  newsletter_posts,
  post_comments,
  reviews,
  websites,
  spaces,
  courses,
};
